// Welche Firma(en) auf der offenen Seite stehen — fuer den Schnellzugriff im
// Plus-Knopf. Der Knopf haengt in den Routes, die Firmen kennt nur die Seite; ein
// Kontext waere derselbe Umweg mit mehr Teilen.
//
// ponytail: zuletzt angemeldete Seite gewinnt. Seiten schachteln sich nicht.
import { useEffect, useSyncExternalStore } from "react";

let current = null;
const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * Seite meldet ihre Firma(en) an:
 *   usePageCompany(order.companyId, order.company?.name)
 *   usePageCompany(shipment.companyIds)   // mehrere: Sendung, Luftfracht
 *
 * `name` gilt nur fuer eine einzelne Firma — bei mehreren werden die Namen im
 * Auswahlfenster nachgeladen.
 */
export const usePageCompany = (companies, name) => {
  const ids = (Array.isArray(companies) ? companies : [companies]).filter(Boolean);
  // Die Liste ist bei jedem Rendern neu; der Schluessel ist es nicht.
  const key = ids.join(",");

  useEffect(() => {
    if (!key) return undefined;
    const list = key.split(",");
    const entry = list.map((id) => ({ id, name: list.length === 1 ? name : undefined }));
    current = entry;
    notify();
    return () => {
      if (current !== entry) return;
      current = null;
      notify();
    };
  }, [key, name]);
};

export const usePageCompanyValue = () => useSyncExternalStore(subscribe, () => current);

/**
 * Braucht der Plus-Knopf die Firmenauswahl, bevor das Formular aufgeht?
 *
 * Genau eine vorgeschlagene Firma wird uebernommen — der Auswahlschritt haette
 * nichts zu entscheiden. Mehrere (Sendung, Luftfracht) muessen gewaehlt werden. Ohne
 * Vorschlag kommt nur der Anruf nicht aus: er zeigt die Nummern der Firma, ohne sie
 * hat er nichts. Termin, Notiz und Aufgabe tragen die Firmensuche im Formular,
 * die Mail braucht keine Firma.
 */
export const needsCompanyPicker = (kind, suggested) => {
  if (suggested?.length === 1) return false;
  return kind === "call" || Boolean(suggested?.length);
};
